import React, { createRef } from 'react';
import PropTypes from 'prop-types';

import {
	AnswerListWrapper,
} from './questionsStyles';

import Answer from './Answer';
import { getActiveVote } from './utils';


class AnswerList extends React.Component {
	wrapper = createRef()

	componentDidMount() {
		const { open } = this.props;
		open && this.toggle();
	}

	componentDidUpdate(prevProps) {
		const { open } = this.props;
		if (prevProps.open === open) {
			return;
		}

		this.toggle();
	}

	toggle = () => {
		// Slick trick ... setting maxHeight = scrollHeight makes it "slide" up/down
		// Adapted from this comment: https://davidwalsh.name/css-slide#comment-507500
		const wrapper = this.wrapper.current;
		if (this.props.open) {
			wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
		} else {
			wrapper.style.maxHeight = null;
		}
	}

	handleAnswerToggle = (on) => {
		const wrapper = this.wrapper.current;
		if (on) {
			// TruncatedContent child views can change the height of this element
			// when those are "on" lets relax the maxHeight so we don't clip content
			wrapper.style.maxHeight = "none";
		} else {
			wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
		}
	}

	handleVote(answer, upVote) {
		this.props.onVote(answer, upVote);
	}

	render() {
		const { answers, answerUpVotes, answerDownVotes, customerId } = this.props;
		return (
			<AnswerListWrapper ref={this.wrapper}>
				{answers.map(answer =>
					<Answer
						key={`answer-${answer.id}`}
						{...answer}
						activeVote={getActiveVote(answer.id, answerUpVotes, answerDownVotes)}
						onVote={(upVote) => this.handleVote(answer, upVote)}
						onToggle={this.handleAnswerToggle}
						customerId={customerId}
					/>
				)}
			</AnswerListWrapper>
		);
	}
}

AnswerList.propTypes = {
	customerId: PropTypes.number,
	answers: PropTypes.array,
	open: PropTypes.bool,
	onVote: PropTypes.func.isRequired,
	answerUpVotes: PropTypes.array,
	answerDownVotes: PropTypes.array,
};

AnswerList.defaultProps = {
	answers: [],
	answerUpVotes: [],
	answerDownVotes: [],
};

export default AnswerList;
